import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import { canUseDOM } from '../../../utils';
var InfiniteCarousel = function InfiniteCarousel(_ref) {
  var direction = _ref.direction,
    images = _ref.images,
    rtl = _ref.rtl;
  var trackRef = useRef(null);
  var positionRef = useRef(direction === 'left' ? 0 : -350); // using useRef here? to avoid unnecessary re-renders
  var animationFrameId = useRef(null); // need for correct work of rtl mode
  var speed = 1;
  var _useState = useState(function () {
      return canUseDOM && window.matchMedia("(max-width: 992px)").matches ? 190 : 350;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    itemWidth = _useState2[0],
    setItemWidth = _useState2[1]; // 180 + 5 + 5 (margin) or width 340 + 5 + 5 (margin)

  var itemWidthRef = useRef(itemWidth);
  useEffect(function () {
    var handleResize = function handleResize() {
      var newWidth = window.matchMedia("(max-width: 992px)").matches ? 190 : 350;
      setItemWidth(newWidth);
      itemWidthRef.current = newWidth;
    };
    if (canUseDOM) {
      window.addEventListener("resize", handleResize);
    }
    return function () {
      if (canUseDOM) {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);
  var _animate = function animate() {
    var track = trackRef.current;
    if (!track) return;
    if (direction === "left") {
      positionRef.current -= speed;
    } else if (direction === "right") {
      positionRef.current += speed;
    }
    track.style.transform = "translateX(".concat(positionRef.current, "px)");
    var items = track.children; // 'carousel-item'
    if (!items.length) return;
    var currentItemWidth = itemWidthRef.current;
    if (direction === "left" && Math.abs(positionRef.current) >= currentItemWidth) {
      track.appendChild(items[0]);
      positionRef.current += currentItemWidth;
      track.style.transform = "translateX(".concat(positionRef.current, "px)");
    } else if (direction === "right" && positionRef.current >= 0) {
      var lastItem = items[items.length - 1];
      track.insertBefore(lastItem, items[0]);
      positionRef.current -= currentItemWidth;
      track.style.transform = "translateX(".concat(positionRef.current, "px)");
    }
    animationFrameId.current = requestAnimationFrame(_animate);
  };
  useEffect(function () {
    if (animationFrameId.current) cancelAnimationFrame(animationFrameId.current);
    animationFrameId.current = requestAnimationFrame(_animate);
    return function () {
      if (animationFrameId.current) cancelAnimationFrame(animationFrameId.current);
    };
  }, [direction, rtl]);
  return /*#__PURE__*/React.createElement("div", {
    className: "carousel-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "carousel-track",
    ref: trackRef,
    style: {
      direction: rtl ? "ltr" : "ltr"
    }
  }, images.map(function (_ref2, index) {
    var image = _ref2.image;
    return /*#__PURE__*/React.createElement("div", {
      className: "carousel-item",
      key: index
    }, /*#__PURE__*/React.createElement("img", {
      src: image.jss.value.src,
      alt: image.jss.value.alt
    }));
  })));
};
export default InfiniteCarousel;